var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPochtabank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0V0Z",
    fill: "#DD002E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 9.7998V30.1998H10.7V12.9998H15.2V30.1998H18.9V9.7998H7ZM33.9 23.2998C33.8 20.9998 33 16.4998 27.2 16.4998L27.1 16.3998H25.4V13.0998H31.9V9.7998H21.9V30.1998H27.5C28.4 30.1998 29.3 29.9998 30.1 29.6998C30.9 29.3998 31.6 28.7998 32.2 28.1998C32.8 27.4998 33.3 26.7998 33.6 25.8998C33.9 25.0998 34 24.1998 33.9 23.2998ZM26.7 26.8998C26.3 26.8998 25.4 26.6998 25.4 26.6998V19.4998H26.1C28 19.4998 30.1 19.2998 30.1 23.0998C30.1 26.6998 27.8 26.8998 26.7 26.8998Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPochtabank);
export default __webpack_public_path__ + "static/media/pochtabank.b1a43bc7721258df3d61a9783889b0b5.svg";
export { ForwardRef as ReactComponent };